import React from 'react';

import { AttentionCircleIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button';

import { queryClient } from '@vlabs/api';
import { useGetDepartment } from '@vlabs/api/artemy/client';
import type { DepartmentId } from '@vlabs/api/artemy/model';

import st from './AttachDepartmentGroupsConfirmation.module.sass';
import { useConfirmAttachDepartmentGroupsTranslation } from './i18n';

interface AttachDepartmentGroupsConfirmationProps {
  departmentId: DepartmentId;
  onConfirm: VoidFunction;
  onReject: VoidFunction;
}

function AttachDepartmentGroupsConfirmation({
  departmentId,
  onConfirm,
  onReject,
}: AttachDepartmentGroupsConfirmationProps): React.JSX.Element {
  const { t } = useConfirmAttachDepartmentGroupsTranslation();
  const { data } = useGetDepartment(departmentId, undefined, queryClient);
  const departmentName = data?.name ?? t('unknown_title');

  return (
    <div className={st.Root}>
      <div className={st.Header}>
        <AttentionCircleIcon className={st.Icon} />
        <div className={st.Description}>
          <span className={st.Title}>
            {t('title')}
          </span>
          <span className={st.Details}>
            {t('details', { departmentName })}
          </span>
        </div>
      </div>

      <div className={st.Actions}>
        <Button
          kind="secondary"
          onClick={onReject}
          variant="outlined"
        >
          {t('reject')}
        </Button>
        <Button
          kind="attention"
          onClick={onConfirm}
          variant="filled"
        >
          {t('confirm')}
        </Button>
      </div>
    </div>
  );
}

export { AttachDepartmentGroupsConfirmation };
